/**
 * @generated SignedSource<<fef506227f5692ba44e051b62e74fc51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RegistrationPageLoginMutation$variables = {
  email: string;
  password: string;
};
export type RegistrationPageLoginMutation$data = {
  readonly tokenAuth: {
    readonly token: string;
  } | null;
};
export type RegistrationPageLoginMutation = {
  response: RegistrationPageLoginMutation$data;
  variables: RegistrationPageLoginMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "password"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "password",
        "variableName": "password"
      }
    ],
    "concreteType": "ObtainJSONWebToken",
    "kind": "LinkedField",
    "name": "tokenAuth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RegistrationPageLoginMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RegistrationPageLoginMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1994511e630ce7f14737da9af5da3c65",
    "id": null,
    "metadata": {},
    "name": "RegistrationPageLoginMutation",
    "operationKind": "mutation",
    "text": "mutation RegistrationPageLoginMutation(\n  $email: String!\n  $password: String!\n) {\n  tokenAuth(email: $email, password: $password) {\n    token\n  }\n}\n"
  }
};
})();

(node as any).hash = "285a12e34f38cb735db478fa3f64ff8f";

export default node;
